import { useProjects } from '@cascade/react/projects';
import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { HOME_PATH } from '#config/index.ts';

export const DependentsGate = ({ children }: PropsWithChildren) => {
  const { canManageDependents } = useProjects();

  if (!canManageDependents) {
    return <Navigate to={HOME_PATH} replace />;
  }

  return children;
};
